import { render } from "./match-details-table-legend.vue?vue&type=template&id=4595543e&ts=true"
import script from "./match-details-table-legend.vue?vue&type=script&lang=ts"
export * from "./match-details-table-legend.vue?vue&type=script&lang=ts"

import "./match-details-table-legend.vue?vue&type=style&index=0&id=4595543e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__